import { ThemeProvider } from '@mui/material/styles'
import { RouterProvider } from 'react-router-dom'

import { createAppRouter } from 'utils/router-provider/createAppRouter'
import './App.css'
import { AuthProvider } from './hoc/AuthProvider'
import { useAppSelector } from './store/hooks'
import { fontTheme } from './styles/font'
import './styles/font.css'
const theme = fontTheme

function App() {
	const { permissions } = useAppSelector(state => state.authReducer)
	const router = createAppRouter(permissions)

	return (
		<AuthProvider>
			<ThemeProvider theme={theme}>
				<RouterProvider router={router} />
			</ThemeProvider>
		</AuthProvider>
	)
}

export default App
